export class TransportPlanData {
  constructor(
    public transportPlanAsHtml: string,
    public changedAt: string
  ) {
  }

  public static fromJSON(json: {
    transportPlanAsHtml: string,
    changedAt: string,
  }): TransportPlanData {
    if (!json) {
      throw new Error('TransportPlanData JSON should not be undefined');
    }
    if (!json.transportPlanAsHtml) {
      throw new Error('TransportPlanData JSON should have property: transportPlanAsHtml');
    }
    if (!json.changedAt) {
      throw new Error('TransportPlanData JSON should have property: changedAt');
    }

    return new TransportPlanData(
      json.transportPlanAsHtml,
      json.changedAt
    );
  }

  // ===== Convenience initializer ===== //


  // ===== Public helper/convenience getters ===== //


}
